import api from 'data/api';

export const loadActionTypes = api(
  'GET /api/mobile/finance/lookups/actiontypes'
);
